import { initLatestCPTBlock } from './utils/latest-cpt/frontend';

initLatestCPTBlock({
	containerSelector: '.wp-block-welko-latest-ressources',
	blockPrefix: 'wp-block-welko-latest-ressources',
	ajaxActionFilter: 'welko_latest_ressources_term_filter',
	ajaxActionLoadmore: 'welko_latest_ressources_loadmore',
});
